export default __webpack_public_path__ + "static/media/Rectangle 249.80787153.png";